'use client';

import dynamic from 'next/dynamic';

export const TrustedShops = dynamic(
  () =>
    import(/* webpackChunkName: 'TrustedShops' */ './TrustedShops.client').then(
      (mod) => mod.TrustedShops,
    ),
  {
    ssr: false,
  },
);
